export const maharashtraData = {
    "Ahmednagar": ["Ahmednagar", "Sangamner", "Kopargaon", "Shrirampur", "Rahuri"],
    "Akola": ["Akola", "Akot", "Balapur", "Murtizapur"],
    "Amravati": ["Amravati", "Achalpur", "Anjangaon", "Warud"],
    "Chhatrapati Sambhajinagar": ["Chhatrapati Sambhajinagar", "Paithan", "Vaijapur", "Gangapur"],
    "Beed": ["Beed", "Parli", "Ambejogai", "Majalgaon"],
    "Bhandara": ["Bhandara", "Tumsar", "Pauni"],
    "Buldhana": ["Buldhana", "Khamgaon", "Shegaon", "Malkapur"],
    "Chandrapur": ["Chandrapur", "Ballarpur", "Bhadravati", "Rajura"],
    "Dhule": ["Dhule", "Shirpur", "Dondaicha", "Sindkheda"],
    "Gadchiroli": ["Gadchiroli", "Desaiganj", "Aheri"],
    "Gondia": ["Gondia", "Tirora", "Amgaon"],
    "Hingoli": ["Hingoli", "Kalamnuri", "Basmath"],
    "Jalgaon": ["Jalgaon", "Bhusawal", "Amalner", "Chalisgaon"],
    "Jalna": ["Jalna", "Ambad", "Partur", "Bhokardan"],
    "Kolhapur": ["Kolhapur", "Ichalkaranji", "Jaysingpur", "Kagal", "Gadhinglaj", "Kurundwad", "Murgud", "Panhala"],
    "Latur": ["Latur", "Udgir", "Ausa", "Nilanga"],
    "Mumbai City": ["Mumbai"],
    "Mumbai Suburban": ["Andheri", "Borivali", "Bandra", "Kurla"],
    "Nagpur": ["Nagpur", "Kamptee", "Umred", "Katol"],
    "Nanded": ["Nanded", "Degloor", "Loha", "Mukhed"],
    "Nandurbar": ["Nandurbar", "Shahada", "Navapur"],
    "Nashik": ["Nashik", "Malegaon", "Manmad", "Igatpuri", "Sinnar"],
    "Dharashiv": ["Dharashiv", "Tuljapur", "Omerga", "Kallam"],
    "Palghar": ["Palghar", "Vasai-Virar", "Dahanu", "Boisar"],
    "Parbhani": ["Parbhani", "Gangakhed", "Pathri", "Selu"],
    "Pune": ["Pune", "Pimpri-Chinchwad", "Baramati", "Lonavala", "Talegaon Dabhade", "Shirur", "Saswad"],
    "Raigad": ["Alibag", "Panvel", "Khopoli", "Karjat", "Pen", "Uran"],
    "Ratnagiri": ["Ratnagiri", "Chiplun", "Dapoli", "Khed", "Rajapur"],
    "Sangli": ["Sangli", "Miraj", "Vita", "Islampur", "Tasgaon", "Ashta"],
    "Satara": ["Satara", "Karad", "Phaltan", "Wai", "Mahabaleshwar", "Panchgani"],
    "Sindhudurg": ["Oros", "Kankavli", "Malvan", "Sawantwadi", "Vengurla"],
    "Solapur": ["Solapur", "Pandharpur", "Barshi", "Akkalkot", "Mangalwedha"],
    "Thane": ["Thane", "Kalyan-Dombivli", "Mira-Bhayandar", "Bhiwandi", "Ulhasnagar", "Ambernath", "Badlapur"],
    "Wardha": ["Wardha", "Hinganghat", "Arvi"],
    "Washim": ["Washim", "Karanja", "Risod"],
    "Yavatmal": ["Yavatmal", "Pusad", "Umarkhed", "Wani"]
};
